export const JOBS_ROUTE = "/jobs";
export const JOBS_APPROVAL_ROUTE = "/approvals/jobs";
